module.exports = __webpack_public_path__ + "img/cases-brand-suning--lazyload-23.bfcab7dc.jpg";